export interface IDonorShieldDirectAddEdit {
    id: number;
    watrId: number;
    centerId: number;
    isBilled: boolean;
    surgeryDate: string;
    donorId: number;
    donorUnosId: string;
    donorAlias: string;
    donorEmail: string;
    donorAboType: number;
    donorGender: number;
    donorName: string;
    donorAddressLine1: string;
    donorAddressLine2: string;
    donorCity: string;
    donorState: number;
    donorPostalCode: string;
    donorPhoneNumber: string;
    donorBirthdate: string;
    organType: number;
    recipientAlias: string;
    recipientEmail: string;
    recipientFirstName: string;
    recipientLastName: string;
    recipientAboType: number;
    recipientUnosCpra: string;
    recipientGender: number;
    recipientBirthdate: string;
    recipientPrimaryInsurance: number;
    recipientSecondaryInsurance: number;
    country: number;
    countryOfCitizenship: number;
    hasStreamlinedSerologyOrder: boolean;
}
